<template>
  <div class="container">
    <div class="share_container">
      <div class="flex-column">
        <div style="position: fixed;top: 5%;">
          <img src="../../../../assets/images/shareHeader.png"
               alt="" />
        </div>
        <div class="shareCenter">
          <div class="codeBoxBorder">
            <div style="padding:14px">
              <vue-qr :text="imageUrl"
                      :size="200"
                      :logoScale="0.2"
                      :margin="2"> </vue-qr>
            </div>

          </div>
          <div class="bottomContent">
            <div class="shareButton">长按图片即可保存</div>

            <!-- <div class="Refresh"
                 @click="init">
              <div class="refsh">
                <img src="../../../../assets/images/refsh.png"
                     alt="" />
              </div>
              刷新
            </div> -->
          </div>
        </div>

        <div class="bottomShareCode">
          <div style="position: relative;">
            <!-- <div>
              <img src="../../../../assets/images/shareCodeBottom.png"
                   alt="" />
            </div> -->
            <div class="avatarUrl">
              <img mode="aspectFill"
                   :src="userInfo.avatarUrl"
                   class="image" />
            </div>

          </div>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import vueQr from "vue-qr";
import { Toast, Dialog, Button, Empty } from "vant";
import { mapGetters } from "vuex";
import service from "../../../api/userCenterPage/userCenterPage.js";
export default {
  // name: "qecode",
  data () {
    return {
      imageUrl: "",
      // isShow: false
    };
  },
  components: {
    [Toast.name]: Toast,
    [Dialog.name]: Dialog,
    [Button.name]: Button,
    [Empty.name]: Empty,
    vueQr,
  },
  computed: {
    ...mapGetters(["userInfo"]),
  },
  mounted () {
    this.init();
  },
  methods: {
    init () {
      service
        .userShareCodeUrl()
        .then((res) => {
          console.log(res.data, 52);
          if (res.statusCode == 200) {
            this.imageUrl = res.data;
          } else {
            Toast(res.errors);
          }
          // this.isShow = true;
        })
        .catch((err) => {
          // Toast(err);
          // Toast("什么都没有哦...");
          // this.isShow = false;
        });
    },
  },
};
</script>
<style lang="less" scoped>
.container {
  overflow: hidden;
}
.codeBoxBorder {
  background-image: url(../../../../assets/images/shareCodeBox.png);
  background-repeat: no-repeat;
  background-size: cover;
  background-position: center;
  width: 254px;
  height: 254px;
  // position: fixed;
  // z-index: 2;
  // top: 50%;
  // margin-top: -190px;
}
.shareCenter {
  position: fixed;
  z-index: 2;
  top: 50%;
  margin-top: -175px;
}
.bottomShareCode {
  background-image: url(../../../../assets/images/shareCodeBottom.png);
  background-repeat: no-repeat;
  background-size: cover;
  background-position: center;
  bottom: 0;
  position: fixed;
  z-index: 2;
  width: 100%;
  height: 209px;
}
.share_container {
  background: linear-gradient(to bottom, #ffffff, #b0e1fa);
  // background-image: url(../../../../assets/images/shareCodeBackGround.png);
  // background-repeat: no-repeat;
  // background-size: 100vw 100vh;
  height: 100vh;
  // display: flex;
  // image-rendering: -webkit-optimize-contrast;
  img {
    display: block;
  }
  .bottomContent {
    display: flex;
    margin: auto;
    justify-content: center;
    width: 100%;
    position: absolute;
    z-index: 1;
    align-items: center;
    flex-direction: column;
    letter-spacing: 0.53333vw;
  }
  .Refresh {
    margin-top: 12px;
    font-size: 4.6vw;
    color: #9c9999;
    display: flex;
    align-items: center;
  }

  .refsh {
    width: 18px;
    height: 16px;
    margin-right: 1vw;
  }

  .shareButton {
    .button {
      height: 36px;
      width: 210px;
      background: linear-gradient(to right, #ec784e 10%, #ea6667, #e85382);
    }
    color: #005ead;
    font-size: 4.6vw;
    margin-top: 20px;
    // position: absolute;
    // z-index: 1;
  }

  .shareTitle {
    // width: 293px;
    // background: linear-gradient(to right, #d04c97 40%, #b544c3,#ad41d0);
    font-size: 36px;
    font-weight: normal;
    font-style: italic;
    color: #fdd880;
    text-shadow: 0px 13px 13px rgba(146, 5, 23, 0.59);
    margin: 8vw 0 6vw;
  }

  .flex-column {
    width: 100%;
  }

  .qr {
    width: 56vw;
    height: 56vw;
    margin: auto;
    padding-top: 8vw;
  }

  .avatarUrl {
    border-radius: 50%;
    position: absolute;
    z-index: 1;
    top: 28.1vw;
    right: 17.2vw;
    .image {
      width: 70px;
      height: 70px;
      border-radius: 50%;
      display: block;
    }
  }

  .codeBox {
    display: flex;
    flex-direction: column;
    width: 84vw;
    height: 90vw;
    text-align: center;
    background-color: RGBA(255, 254, 254, 1);
    border-radius: 5px;
  }
}
</style>
